import React, { Component } from "react";

import { Grid, Typography, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import DispatchImage from "../../../resources/images/dispatch-icon.svg";

const styles = {
  cardTitle: {
    background: "#253239",
    padding: "0.5rem 1rem",
  },
  cardTitleText: {
    color: "#ffffff",
    fontSize: "1.05rem",
  },
  card: {
    padding: "0.5rem 1rem",
    border: "1px solid #c1c1c1",
    borderTopWidth: 0,
  },
  poImg: {
    width: "100%",
  },
  divider: {
    margin: "0.5rem -1rem",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
  mr: {
    // color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  wrapText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};

class Summary extends Component {
  render() {
    const { classes, summaryData, renderTableData, month } = this.props;
    return (
      <Grid item xs={12} sm={6} md={4}>
        <Grid item xs={12} className={classes.cardTitle}>
          <Typography variant="h6" className={classes.cardTitleText}>
            Overview
          </Typography>
        </Grid>
        {summaryData === false ? (
          <div
            style={{
              border: "1px solid #c1c1c1",
              minHeight: "13.4rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1">Loading...</Typography>
          </div>
        ) : (
          <div className={classes.card}>
            <Grid item xs={12}>
              <Grid container spacing={2} className={classes.flex}>
                <Grid item xs={2}>
                  <img
                    src={DispatchImage}
                    alt="Purchase Orders"
                    className={classes.poImg}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "1.25rem",
                    }}
                    color="secondary"
                  >
                    Dispatched
                  </Typography>
                </Grid>
                <Grid item xs={2} className={classes.flexEnd}>
                  {parseInt(summaryData.dispatched) === 0 ? (
                    <Typography
                      variant="h5"
                      color="secondary"
                      className={classes.wrapText}
                    >
                      {summaryData.dispatched}
                    </Typography>
                  ) : (
                    <Typography
                      variant="h5"
                      color="secondary"
                      className={`${classes.mr} ${classes.wrapText}`}
                      onClick={() =>
                        renderTableData("line", 2, 0, "Overview", "Dispatched")
                      }
                    >
                      {summaryData.dispatched}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Committed For {month}
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(summaryData.row1) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {summaryData.row1}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "line",
                        2,
                        1,
                        "Overview",
                        `Committed For ${month}`
                      )
                    }
                  >
                    {summaryData.row1}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Carry forward from past months
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(summaryData.row2) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {summaryData.row2}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "line",
                        2,
                        2,
                        "Overview",
                        "Carry forward from past months"
                      )
                    }
                  >
                    {summaryData.row2}
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Divider className={classes.divider} />

            <Grid container spacing={2} className={classes.flex}>
              <Grid item xs={10}>
                <Typography variant="body2" className={classes.wrapText}>
                  Committed for future months
                </Typography>
              </Grid>
              <Grid item xs={2} className={classes.flexEnd}>
                {parseInt(summaryData.row3) === 0 ? (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={classes.wrapText}
                  >
                    {summaryData.row3}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    color="secondary"
                    className={`${classes.mr} ${classes.wrapText}`}
                    onClick={() =>
                      renderTableData(
                        "line",
                        2,
                        3,
                        "Overview",
                        "Committed for future months"
                      )
                    }
                  >
                    {summaryData.row3}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles)(Summary);
